import React from "react";
import Sale from "../../components/lo5d/SaleV2";
import Lotto5DNav from "../../components/lo5d/Lotto5DNav";
import MainDrawingWrapper from "../../components/lo5d/MainDrawingWrapper";

class Lotto5DDashboard extends React.Component {

    render() {
        return (
            <div className="main-w">
                <div className="main">
                    <div className="w-1200">
                        <div className="wrapper-new-lotto5 lotto5">
                            <MainDrawingWrapper>
                                <Lotto5DNav/>
                                <Sale />
                            </MainDrawingWrapper>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default Lotto5DDashboard;
